const drawer = document.querySelector('[data-cart-drawer]');
const overlay = document.querySelector('[data-cart-overlay]');

function openCart() {
  drawer?.classList.add('open');
  drawer?.setAttribute('aria-hidden', 'false');
  if (overlay) overlay.hidden = false;
  refreshCart();
}

function closeCart() {
  drawer?.classList.remove('open');
  drawer?.setAttribute('aria-hidden', 'true');
  if (overlay) overlay.hidden = true;
}

document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', openCart));
document.querySelector('[data-cart-close]')?.addEventListener('click', closeCart);
overlay?.addEventListener('click', closeCart);

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-quick-add], [data-ajax-product-form]');
  if (!form) return;

  event.preventDefault();
  const submitter = event.submitter;
  if (form.matches('[data-ajax-product-form]') && !submitter?.matches('[data-add-to-cart]')) return;
  const goToCheckout = submitter?.name === 'checkout';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });

    if (!response.ok) throw new Error('Unable to add product');

    await refreshCart();

    if (goToCheckout) {
      window.location.href = '/checkout';
      return;
    }

    openCart();
  } catch (error) {
    alert('This item could not be added. Please choose an available option.');
  }
});

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-qty]');
  if (!button) return;

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      line: Number(button.dataset.qty),
      quantity: Number(button.dataset.value)
    })
  });

  refreshCart();
});

async function refreshCart() {
  const cart = await fetch('/cart.js').then((response) => response.json());

  document.querySelectorAll('[data-cart-count]').forEach((element) => {
    element.textContent = cart.item_count;
  });

  document.querySelector('[data-cart-total]')?.replaceChildren(
    document.createTextNode(formatMoney(cart.total_price))
  );

  const items = document.querySelector('[data-cart-items]');
  if (items) {
    items.innerHTML = cart.items.map((item, index) => {
      const properties = Object.entries(item.properties || {})
        .filter(([, value]) => value)
        .map(([key, value]) => `<small><b>${escapeHtml(key)}:</b> ${escapeHtml(String(value))}</small>`)
        .join('');

      return `
        <div class="drawer-item">
          <img src="${item.image || ''}" alt="">
          <div>
            <b>${escapeHtml(item.product_title)}</b>
            <small>${escapeHtml(item.variant_title || '')}</small>
            ${properties}
            <strong>${formatMoney(item.final_line_price)}</strong>
            <div class="qty">
              <button data-qty="${index + 1}" data-value="${Math.max(0, item.quantity - 1)}">−</button>
              <span>${item.quantity}</span>
              <button data-qty="${index + 1}" data-value="${item.quantity + 1}">+</button>
            </div>
          </div>
        </div>`;
    }).join('') || '<p>Your cart is empty.</p>';
  }

  const threshold = 7500;
  const away = Math.max(0, threshold - cart.total_price);
  document.querySelector('[data-shipping-away]')?.replaceChildren(
    document.createTextNode(away ? formatMoney(away) : 'Nothing — you unlocked')
  );

  const bar = document.querySelector('[data-shipping-bar]');
  if (bar) bar.style.width = `${Math.min(100, (cart.total_price / threshold) * 100)}%`;
}

function formatMoney(cents) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(cents / 100);
}

function escapeHtml(value) {
  return value.replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#039;',
    '"': '&quot;'
  })[character]);
}

function initializeRuffleBuilder(builder) {
  const form = builder.querySelector('[data-ruffle-product-form]');
  const variantsElement = builder.querySelector('[data-ruffle-variants]');
  if (!form || !variantsElement) return;

  const variants = JSON.parse(variantsElement.textContent);
  const variantInput = form.querySelector('[data-ruffle-variant-id]');
  const price = builder.querySelector('[data-ruffle-price]');
  const addButton = form.querySelector('[data-ruffle-add]');
  const addLabel = form.querySelector('[data-ruffle-add-label]');
  const buyNowButton = form.querySelector('button[name="checkout"]');
  const mainImage = builder.querySelector('[data-ruffle-main-image]');

  function updateVariant() {
    const selectedOptions = [...form.querySelectorAll('[data-ruffle-option]:checked')]
      .map((input) => input.value);

    const variant = variants.find((item) =>
      item.options.every((option, index) => option === selectedOptions[index])
    );

    if (!variant) {
      if (addButton) addButton.disabled = true;
      if (buyNowButton) buyNowButton.disabled = true;
      if (addLabel) addLabel.textContent = 'Unavailable';
      return;
    }

    variantInput.value = variant.id;
    if (price) price.textContent = formatMoney(variant.price);

    const available = Boolean(variant.available);
    if (addButton) addButton.disabled = !available;
    if (buyNowButton) buyNowButton.disabled = !available;
    if (addLabel) addLabel.textContent = available ? '🧶 Add to My Bundle' : 'Sold Out';

    if (variant.featured_image?.src && mainImage) {
      mainImage.src = variant.featured_image.src;
      builder.querySelectorAll('[data-ruffle-thumb]').forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.dataset.ruffleThumb.includes(variant.featured_image.id));
      });
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  form.querySelectorAll('[data-ruffle-option]').forEach((input) => {
    input.addEventListener('change', updateVariant);
  });

  builder.querySelectorAll('[data-ruffle-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (mainImage) mainImage.src = thumb.dataset.ruffleThumb;
      builder.querySelectorAll('[data-ruffle-thumb]').forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  const quantityInput = form.querySelector('[data-ruffle-quantity]');
  form.querySelector('[data-ruffle-quantity-minus]')?.addEventListener('click', () => {
    quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
  });
  form.querySelector('[data-ruffle-quantity-plus]')?.addEventListener('click', () => {
    quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + 1);
  });
}

document.querySelectorAll('[data-ruffle-builder]').forEach(initializeRuffleBuilder);

function initializeQuickAddModal(modal) {
  if (!modal || modal.dataset.initialized === 'true') return;
  modal.dataset.initialized = 'true';

  const form = modal.querySelector('[data-quick-add-form]');
  const variantsNode = modal.querySelector('[data-quick-add-variants]');
  const variantInput = modal.querySelector('[data-quick-add-variant-id]');
  const price = modal.querySelector('[data-quick-add-price]');
  const submit = modal.querySelector('[data-quick-add-submit]');
  const submitText = modal.querySelector('[data-quick-add-submit-text]');
  const image = modal.querySelector('[data-quick-add-image]');
  const optionInputs = [...modal.querySelectorAll('[data-quick-option-input]')];
  if (!form || !variantsNode || !variantInput) return;

  let variants = [];
  try {
    variants = JSON.parse(variantsNode.textContent);
  } catch (error) {
    console.error('Unable to read quick-add variants.', error);
    return;
  }

  function selectedOptions() {
    return optionInputs
      .filter((input) => input.checked)
      .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex))
      .map((input) => input.value);
  }

  function updateLabels() {
    modal.querySelectorAll('[data-quick-option-position]').forEach((fieldset) => {
      const checked = fieldset.querySelector('[data-quick-option-input]:checked');
      const label = fieldset.querySelector('[data-quick-selected-option]');
      if (checked && label) label.textContent = checked.value;
    });
  }

  function updateVariant() {
    updateLabels();
    const options = selectedOptions();
    const variant = variants.find((item) =>
      item.options.every((option, index) => option === options[index])
    );

    if (!variant) {
      variantInput.value = '';
      if (submit) submit.disabled = true;
      if (submitText) submitText.textContent = 'Unavailable';
      return;
    }

    variantInput.value = variant.id;
    if (price) price.textContent = formatMoney(variant.price);
    if (submit) submit.disabled = !variant.available;
    if (submitText) submitText.textContent = variant.available ? '🧶 Add to My Bundle' : 'Sold Out';

    if (variant.featured_image?.src && image) {
      image.src = variant.featured_image.src;
    }
  }

  optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
  modal.querySelector('[data-quick-add-close]')?.addEventListener('click', () => modal.close());
  modal.addEventListener('click', (event) => {
    if (event.target === modal) modal.close();
  });
  form.addEventListener('submit', () => {
    setTimeout(() => modal.close(), 150);
  });

  updateVariant();
}

document.querySelectorAll('[data-quick-add-modal]').forEach(initializeQuickAddModal);

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-quick-add-open]');
  if (!opener) return;
  const modal = document.getElementById(opener.dataset.quickAddOpen);
  if (!modal) return;
  initializeQuickAddModal(modal);
  if (typeof modal.showModal === 'function') modal.showModal();
  else modal.setAttribute('open', '');
});
